import { useEffect, useState } from 'react'

import { useStoreActions, useStoreState } from 'easy-peasy'

import { BASE_DURATION_MS, getRemainingMsFromStart, getTodayString } from './Countdown.utils'

export function useLoopingCountdown() {
  const { date, startTime } = useStoreState(({ countdownStore }) => countdownStore)
  const { setCountdownStartForToday } = useStoreActions(({ countdownStore }) => countdownStore)

  const [remainingMs, setRemainingMs] = useState(BASE_DURATION_MS)

  useEffect(
    () => {
      if (typeof window === 'undefined') return

      const today = getTodayString()

      let effectiveStartTime = startTime

      // If no startTime yet, or the stored date is from another day → set new one
      if (!startTime || date !== today) {
        const newStart = Date.now()
        setCountdownStartForToday({ startTime: newStart, date: today })
        effectiveStartTime = newStart
      }

      const update = () => {
        setRemainingMs(getRemainingMsFromStart(effectiveStartTime))
      }

      update()

      const id = window.setInterval(update, 1000)

      return () => window.clearInterval(id)
    },
    // startTime is not listed in dependencies to avoid calling useEffect twice
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [date, setCountdownStartForToday],
  )

  return remainingMs
}
